import React from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useAppContext } from "Main";
import Logo from "components/common/Logo";

const renderTooltip = (props) => (
  <Tooltip style={{ position: "fixed" }} id="button-tooltip" {...props}>
    Toggle Navigation
  </Tooltip>
);

const ToggleButton = () => {
  const {
    config: { isNavbarVerticalCollapsed, isFluid, isRTL },
    setConfig,
  } = useAppContext();

  const handleClick = () => {
    document
      .getElementsByTagName("html")[0]
      .classList.toggle("navbar-vertical-collapsed");
    setConfig("isNavbarVerticalCollapsed", !isNavbarVerticalCollapsed);
  };

  return (
    <OverlayTrigger
      placement={
        isFluid ? (isRTL ? "bottom" : "right") : isRTL ? "bottom" : "left"
      }
      overlay={renderTooltip}
    >
      {/* <div className="toggle-icon-wrapper"> */}
      <div className="">
        <Button
          variant="link"
          style={{ padding: "0" }}
          // className="navbar-toggler-humburger-icon navbar-vertical-toggle"
          id="toggleNavigationTooltip"
          onClick={handleClick}
        >
          {/* <span className="navbar-toggle-icon">
            <span className="toggle-line" />
          </span> */}
          <Logo at="navbar-vertical" textClass="text-primary fs-8" width={32} />
        </Button>
      </div>
    </OverlayTrigger>
  );
};

export default ToggleButton;
